// /* global THREE */
import aframe from "aframe";
// import { bindEvent } from "aframe-event-decorators";

const SpawnVolleyInterval = 1000;
const SpawnBomberInterval = 3000;

aframe.registerComponent("wave-generator", {
  schema: {
    speed: { type: "number", default: 0.03 },
    missiles: { type: "int", default: 11 },
    bombers: { type: "int", default: 0 },
    splitAt: { type: "array" },
    splitSize: { type: "int", default: 0 }
  },
  init() {
    this.started = false;
  },
  update(oldData) {
    if (this.started) {
      throw new Error("Cannot edit wave-generator after it has started.");
    }
  },
  play() {
    if (!this.started) {
      this.el.components["wave-queue"].registerGenerator(this.iter());
      this.timer = 0;
      this.launchCount = 0;
      this.started = true;

      this.missilesToSpawn = this.data.missiles;
      this.bombersToSpawn = this.data.bombers;
    }
  },
  tick(t, dt) {
    this.timer += dt;
  },
  * iter() {
    let prevTime = this.timer;
    let missileLaunchCooldown = 0;
    let bomberSpawnCooldown = 0;

    while (true) {
      if (this.missilesToSpawn === 0 && this.bombersToSpawn === 0) {
        break;
      }

      const dt = this.timer - prevTime;

      const waves = [];

      missileLaunchCooldown -= dt;
      if (missileLaunchCooldown <= 0) {
        missileLaunchCooldown = SpawnVolleyInterval;
        waves.push(...this.missiles());
      }

      bomberSpawnCooldown -= dt;
      if (bomberSpawnCooldown <= 0) {
        bomberSpawnCooldown = SpawnBomberInterval;
        waves.push(...this.bombers());
      }

      prevTime = this.timer;
      yield waves;
    }

    yield "done";
  },
  missiles() {
    const n = Math.min(4, this.missilesToSpawn);
    const waves = [];

    for (let i = 0; i < n; i++) {
      const missileNumber = this.launchCount;
      let splitAt;
      if (this.data.splitAt.indexOf(missileNumber) !== -1) {
        splitAt = randomSplits(this.data.splitSize);
      }

      waves.push({
        type: "missile",
        data: {
          speed: this.data.speed,
          splitAt
        }
      });
      this.launchCount += 1;
      this.missilesToSpawn -= 1;
    }

    return waves;
  },
  bombers() {
    if (this.bombersToSpawn > 0) {
      this.bombersToSpawn -= 1;
      return [{ type: "bomber", data: { bombSpeed: this.data.speed } }];
    } else {
      return [];
    }
  }
});

function randomSplits(n) {
  const splits = [];

  const r = Math.random();
  if (r <= 0.5) {
    for (let i = 0; i < n; i++) {
      splits.push(r / 4);
    }
  } else {
    for (let i = 0; i < n; i++) {
      splits.push((i + 1) * (r - 0.5) / (2 * n));
    }
  }

  return splits;
}

export { randomSplits };
